import AmpService from "analytics/amplitude/amplitudeEvents";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IGuaranteedFitProduct } from "api/interfaces/product-api.type";
import ViewAll from "component/design-system/ViewAll";
import Slider from "component/design-system/carousel/Slider";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import ProductContext from "hooks-contexts/ProductContext";
import { RootState } from "interfaces/generics.type";
import HorizontalProductCard from "modules/components/product-cards/horizontal-product-card/HorizontalProductCard";
import { useTranslation } from "next-i18next";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { getVehicleName } from "util/helper/getVehicleName";
import styles from "./guaranteed-fit-products.module.scss";

interface IGuaranteedFitProductsProps {
  guaranteedFitProducts: IGuaranteedFitProduct[];
  productNotFit: ICompactProduct;
}
const GuaranteedFitProducts = (props: IGuaranteedFitProductsProps) => {
  const { guaranteedFitProducts, productNotFit } = props;
  const { t } = useTranslation("product");
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const vehicleName = getVehicleName(selectedVehicle, ["year", "make", "model"]);
  const { categoryPageRecommendationData } = useContext(ProductContext);

  if (!guaranteedFitProducts.length) {
    return null;
  }

  function cardClickCallback(product: IGuaranteedFitProduct) {
    AmpService.guaranteedFitProduct({ sku: product.sku, vehicle: selectedVehicle, skuWhichDoesnotFit: productNotFit.sku }, "PRODUCT_CARD_CLICKED");
  }

  function addToCartClickCallback(product: IGuaranteedFitProduct) {
    AmpService.guaranteedFitProduct({ sku: product.sku, vehicle: selectedVehicle, skuWhichDoesnotFit: productNotFit.sku }, "ADD_TO_CART_CLICKED");
  }

  function viewAllButtonClick() {
    AmpService.guaranteedFitProduct({ vehicle: selectedVehicle, skuWhichDoesnotFit: productNotFit.sku }, "VIEW_ALL_CLICKED");
  }

  return (
    <div className={styles.guaranteed_fit_products}>
      <div className="d-flex justify-content-between align-items-center">
        <div className={styles.guaranteed_fit_title}>
          <i className={`fa fa-check ${styles.check_mark}`} />
          <PAText component="h2" fontSize={FONT_SIZE[3]} bold>{`${t("Products that fit")} ${vehicleName}`}</PAText>
        </div>
        <ViewAll
          href={categoryPageRecommendationData.href}
          asPath={categoryPageRecommendationData.asPath}
          title="Browse Your Recent Search Activity"
          className="m-b-10 m-t-20"
          onClick={viewAllButtonClick}
        />
      </div>
      <Slider
        tileWidth={350}
        showArrowOnHover
        showScrollOnHover
        liClass={styles.guaranteed_fit_product_card}
      >
        {
          guaranteedFitProducts.map((product) => (
            <HorizontalProductCard
              key={product.longDescription}
              product={product}
              cardClickCallback={() => cardClickCallback(product)}
              addToCartClickCallback={() => addToCartClickCallback(product)}
            />
          ))
        }
      </Slider>
    </div>
  );
};

export default GuaranteedFitProducts;
